export { ScriptLoaderService } from './script-loader.service';
export * from './api.service';
export { ClassService } from './class.service';
export { SharedService } from './shared.service';



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_services/index.ts